<template>
  <div class="remittance-order-page">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="输入手机号" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="群昵称">
          <el-input v-model="searchForm.groupNickname" placeholder="请输入群昵称" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="searchForm.title" placeholder="输入标题" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="是否急速">
          <el-select v-model="searchForm.isUrgent" placeholder="全部" clearable style="width: 120px;">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="截标状态">
          <el-select v-model="searchForm.cutoffStatus" placeholder="全部" clearable style="width: 120px;">
            <el-option label="未截标" :value="0"></el-option>
            <el-option label="已截标" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.orderStatus" placeholder="全部" clearable style="width: 140px;">
            <el-option label="空白" :value="0"></el-option>
            <el-option label="待付款" :value="1"></el-option>
            <el-option label="已付款" :value="6"></el-option>
            <el-option label="交易关闭" :value="2"></el-option>
            <el-option label="待发货" :value="3"></el-option>
            <el-option label="待收货" :value="4"></el-option>
            <el-option label="交易完成" :value="5"></el-option>
            <el-option label="截标" :value="6"></el-option>
            <el-option label="未截标" :value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现状态">
          <el-select v-model="searchForm.withdrawStatus" placeholder="全部" clearable style="width: 120px;">
            <el-option label="未提现" :value="0"></el-option>
            <el-option label="审核中" :value="2"></el-option>
            <el-option label="已提现" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span class="card-title">回款订单列表</span>
        <div style="float: right;">
          <el-button size="small" type="success" icon="el-icon-upload2" @click="handleImport">导入</el-button>
          <el-button size="small" type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </div>
      </div>

      <el-table :data="tableData" v-loading="tableLoading" stripe border>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="群昵称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatGroupNickname(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isUrgentName" label="是否急速" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isUrgent === 1 ? 'danger' : 'info'" size="small">
              {{ scope.row.isUrgentName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatusName" label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getOrderStatusTagType(scope.row.orderStatus)" size="small">
              {{ scope.row.orderStatusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="withdrawStatusName" label="提现状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="getWithdrawStatusTagType(scope.row.withdrawStatus)" size="small">
              {{ scope.row.withdrawStatusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="dealAmount" label="成交金额" width="110" align="right">
          <template slot-scope="scope">
            <span class="amount">{{ scope.row.dealAmount != null ? scope.row.dealAmount + ' 元' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="platformFee" label="平台手续费" width="110" align="right">
          <template slot-scope="scope">
            <span class="amount">{{ scope.row.platformFee != null ? scope.row.platformFee + ' 元' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="merchantFee" label="商家手续费" width="110" align="right">
          <template slot-scope="scope">
            <span class="amount">{{ scope.row.merchantFee != null ? scope.row.merchantFee + ' 元' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="prepaymentAmount" label="预付金额" width="100" align="right">
          <template slot-scope="scope">
            <span class="amount">{{ scope.row.prepaymentAmount != null ? scope.row.prepaymentAmount + ' 元' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="balanceAmount" label="尾款金额" width="100" align="right">
          <template slot-scope="scope">
            <span class="amount">{{ scope.row.balanceAmount != null ? scope.row.balanceAmount + ' 元' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="210">
          <template slot-scope="scope">
            {{ formatDateTimeCn(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #F56C6C;" :disabled="scope.row.withdrawStatus === 2" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="680px" @close="handleDialogClose">
      <el-form :model="form" :rules="formRules" ref="formRef" label-width="120px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="是否急速" prop="isUrgent">
          <el-radio-group v-model="form.isUrgent">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="截标时间" prop="cutoffTime">
          <el-date-picker
            v-model="form.cutoffTime"
            type="datetime"
            placeholder="选择截标时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            style="width: 100%;"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态" prop="orderStatus">
          <el-radio-group v-model="form.orderStatus">
            <el-radio :label="0">空白</el-radio>
            <el-radio :label="1">待付款</el-radio>
            <el-radio :label="2">交易关闭</el-radio>
            <el-radio :label="3">待发货</el-radio>
            <el-radio :label="4">待收货</el-radio>
            <el-radio :label="5">交易完成</el-radio>
            <el-radio :label="6">已截标</el-radio>
            <el-radio :label="7">未截标</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否提现" prop="withdrawStatus">
          <el-radio-group v-model="form.withdrawStatus">
            <el-radio :label="0">未提现</el-radio>
            <el-radio :label="2">审核中</el-radio>
            <el-radio :label="1">已提现</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="成交金额" prop="dealAmount">
          <el-input-number v-model="form.dealAmount" :precision="2" :controls="false" placeholder="请输入成交金额" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="平台手续费" prop="platformFee">
          <el-input-number v-model="form.platformFee" :precision="2" :controls="false" placeholder="请输入平台手续费" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="商家手续费" prop="merchantFee">
          <el-input-number v-model="form.merchantFee" :precision="2" :controls="false" placeholder="请输入商家手续费" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="预付金额" prop="prepaymentAmount">
          <el-input-number v-model="form.prepaymentAmount" :precision="2" :controls="false" placeholder="请输入预付金额" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="尾款金额" prop="balanceAmount">
          <el-input-number v-model="form.balanceAmount" :precision="2" :controls="false" placeholder="请输入尾款金额" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注（选填）" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="回款订单详情" :visible.sync="viewDialogVisible" width="700px">
      <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="群昵称">{{ formatGroupNickname(viewData) }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ viewData.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="标题" :span="2">{{ viewData.title || '-' }}</el-descriptions-item>
        <el-descriptions-item label="是否急速">
          <el-tag :type="viewData.isUrgent === 1 ? 'danger' : 'info'" size="small">{{ viewData.isUrgentName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="截标状态">
          <el-tag :type="viewData.cutoffStatus === 1 ? 'success' : 'warning'" size="small">{{ viewData.cutoffStatusName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="截标时间">{{ formatDateTimeCn(viewData.cutoffTime) }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="getOrderStatusTagType(viewData.orderStatus)" size="small">{{ viewData.orderStatusName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="提现状态">
          <el-tag :type="getWithdrawStatusTagType(viewData.withdrawStatus)" size="small">{{ viewData.withdrawStatusName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="成交金额">{{ viewData.dealAmount != null ? viewData.dealAmount + ' 元' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="平台手续费">{{ viewData.platformFee != null ? viewData.platformFee + ' 元' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="商家手续费">{{ viewData.merchantFee != null ? viewData.merchantFee + ' 元' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="预付金额">{{ viewData.prepaymentAmount != null ? viewData.prepaymentAmount + ' 元' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="尾款金额">{{ viewData.balanceAmount != null ? viewData.balanceAmount + ' 元' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ viewData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDateTimeCn(viewData.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDateTimeCn(viewData.updateTime) }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button type="primary" @click="viewDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog title="导入回款订单" :visible.sync="importDialogVisible" width="500px" @close="handleImportDialogClose">
      <div class="import-tip">
        <p>请上传 Excel 文件（.xlsx 或 .xls），文件需包含以下表头列：</p>
        <ul>
          <li>手机号、标题、是否急速、截标状态、截标时间、订单状态</li>
          <li>成交金额、平台手续费、商家手续费、预付金额、尾款金额、备注</li>
        </ul>
        <p style="margin-top: 8px; color: #909399; font-size: 12px;">提示：是否急速填"是"或"否"；截标状态填"已截标"或"未截标"；订单状态填"截标"/"未截标"/"交易完成"/"待付款"/"交易关闭"/"待发货"/"待收货"</p>
      </div>
      <el-upload
        class="import-uploader"
        ref="uploadRef"
        :auto-upload="false"
        :limit="1"
        accept=".xlsx,.xls"
        :on-change="handleFileChange"
        :file-list="fileList">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
        <div slot="tip" class="el-upload__tip" style="margin-top: 8px;">只能上传 xlsx/xls 文件，且不超过 10MB</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="success" @click="handleImportSubmit" :loading="importLoading">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRemittanceList,
  getRemittance,
  addRemittance,
  updateRemittance,
  deleteRemittance,
  importRemittance,
  exportRemittanceList
} from '@/api/index'

export default {
  name: 'RemittanceOrderManagement',
  data() {
    return {
      searchForm: {
        phone: '',
        groupNickname: '',
        title: '',
        isUrgent: null,
        cutoffStatus: null,
        orderStatus: null,
        withdrawStatus: null
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // dialog
      dialogVisible: false,
      dialogTitle: '新增回款订单',
      isEdit: false,
      submitLoading: false,
      form: {
        phone: '',
        title: '',
        isUrgent: 0,
        cutoffTime: '',
        orderStatus: 0,
        withdrawStatus: 0,
        dealAmount: null,
        platformFee: null,
        merchantFee: null,
        prepaymentAmount: null,
        balanceAmount: null,
        remark: ''
      },
      formRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
      },
      // view dialog
      viewDialogVisible: false,
      viewData: null,
      // import dialog
      importDialogVisible: false,
      importLoading: false,
      fileList: [],
      uploadFile: null
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    formatGroupNickname(row) {
      if (!row) return '-'
      const nickname = row.groupNickname != null ? String(row.groupNickname).trim() : ''
      if (nickname) return nickname
      return row.userName || '-'
    },
    formatDateTimeCn(value) {
      if (!value) return '-'
      const s = String(value).trim()
      if (!s) return '-'
      const normalized = s.replace('T', ' ')
      const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})[ ](\d{2}):(\d{2})(?::(\d{2}))?$/)
      if (!match) return s
      const second = match[6] || '00'
      return `${match[1]}年${match[2]}月${match[3]}日 ${match[4]}时${match[5]}分${second}秒`
    },
    normalizeDateTimeForPicker(value) {
      if (!value) return ''
      const s = String(value).trim()
      if (!s) return ''
      return s.replace('T', ' ').slice(0, 16)
    },
    getOrderStatusTagType(status) {
      const map = { 0: 'info', 1: 'warning', 2: 'danger', 3: 'warning', 4: 'warning', 5: 'success', 6: 'success', 7: 'warning' }
      return map[status] || 'info'
    },
    getWithdrawStatusTagType(status) {
      const map = { 0: 'info', 1: 'success', 2: 'warning' }
      return map[status] || 'info'
    },
    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          phone: this.searchForm.phone || undefined,
          groupNickname: this.searchForm.groupNickname || undefined,
          title: this.searchForm.title || undefined,
          isUrgent: this.searchForm.isUrgent,
          cutoffStatus: this.searchForm.cutoffStatus,
          orderStatus: this.searchForm.orderStatus,
          withdrawStatus: this.searchForm.withdrawStatus
        }
        const res = await getRemittanceList(params)
        this.tableData = res.data?.list || []
        this.pagination.total = res.data?.total || 0
      } catch (e) {
        console.error('加载数据失败', e)
      } finally {
        this.tableLoading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        phone: '',
        groupNickname: '',
        title: '',
        isUrgent: null,
        cutoffStatus: null,
        orderStatus: null,
        withdrawStatus: null
      }
      this.pagination.pageNum = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.pagination.pageNum = page
      this.loadData()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增回款订单'
      this.isEdit = false
      this.form = {
        phone: '',
        title: '',
        isUrgent: 0,
        cutoffTime: '',
        orderStatus: 0,
        withdrawStatus: 0,
        dealAmount: null,
        platformFee: null,
        merchantFee: null,
        prepaymentAmount: null,
        balanceAmount: null,
        remark: ''
      }
      this.dialogVisible = true
    },
    async handleEdit(row) {
      this._editRowId = row.id
      try {
        const res = await getRemittance(row.id)
        const d = res.data
        this.form = {
          phone: d.phone || '',
          title: d.title || '',
          isUrgent: d.isUrgent || 0,
          cutoffTime: this.normalizeDateTimeForPicker(d.cutoffTime),
          orderStatus: d.orderStatus || 0,
          withdrawStatus: d.withdrawStatus || 0,
          dealAmount: d.dealAmount,
          platformFee: d.platformFee,
          merchantFee: d.merchantFee,
          prepaymentAmount: d.prepaymentAmount,
          balanceAmount: d.balanceAmount,
          remark: d.remark || ''
        }
        this.dialogTitle = '编辑回款订单'
        this.isEdit = true
        this.dialogVisible = true
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    async handleView(row) {
      try {
        const res = await getRemittance(row.id)
        this.viewData = res.data
        this.viewDialogVisible = true
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    handleDialogClose() {
      this.$refs.formRef.resetFields()
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        const submitData = {
          phone: this.form.phone || undefined,
          title: this.form.title || undefined,
          isUrgent: this.form.isUrgent,
          cutoffTime: this.form.cutoffTime || undefined,
          orderStatus: this.form.orderStatus,
          withdrawStatus: this.form.withdrawStatus,
          dealAmount: this.form.dealAmount ?? 0,
          platformFee: this.form.platformFee ?? 0,
          merchantFee: this.form.merchantFee ?? 0,
          prepaymentAmount: this.form.prepaymentAmount ?? 0,
          balanceAmount: this.form.balanceAmount ?? 0,
          remark: this.form.remark || undefined
        }
        try {
          if (this.isEdit) {
            const editRow = this._editRowId
            await updateRemittance(editRow, submitData)
            this.$message.success('更新成功')
          } else {
            await addRemittance(submitData)
            this.$message.success('添加成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          console.error(e)
        } finally {
          this.submitLoading = false
        }
      })
    },
    async handleDelete(row) {
      // 检查是否在审核中
      if (row.withdrawStatus === 2) {
        this.$message.error('该订单正在审核提现中，不允许删除')
        return
      }
      try {
        await this.$confirm('确定要删除该回款订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteRemittance(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
    // 导入相关
    handleImport() {
      this.uploadFile = null
      this.fileList = []
      this.importDialogVisible = true
    },
    handleImportDialogClose() {
      this.uploadFile = null
      this.fileList = []
    },
    handleFileChange(file, fileList) {
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('文件大小不能超过 10MB')
        this.fileList = []
        this.uploadFile = null
        return
      }
      this.uploadFile = file.raw
      this.fileList = fileList.slice(-1)
    },
    async handleImportSubmit() {
      if (!this.uploadFile) {
        this.$message.warning('请先选择要导入的 Excel 文件')
        return
      }
      this.importLoading = true
      try {
        const res = await importRemittance(this.uploadFile)
        this.$message.success(`导入成功，共导入 ${res.data?.count || 0} 条数据`)
        this.importDialogVisible = false
        this.loadData()
      } catch (e) {
        console.error(e)
        const msg = e?.message || ''
        if (msg.includes('timeout') || e?.code === 'ECONNABORTED') {
          this.$message.error('导入超时，请稍后刷新列表确认是否已导入成功，或拆分文件后重试')
        } else {
          this.$message.error(msg.includes('导入失败') ? msg : ('导入失败' + (msg ? `: ${msg}` : '')))
        }
      } finally {
        this.importLoading = false
      }
    },

    async handleExport() {
      try {
        const params = {
          phone: this.searchForm.phone || undefined,
          groupNickname: this.searchForm.groupNickname || undefined,
          title: this.searchForm.title || undefined,
          isUrgent: this.searchForm.isUrgent,
          cutoffStatus: this.searchForm.cutoffStatus,
          orderStatus: this.searchForm.orderStatus,
          withdrawStatus: this.searchForm.withdrawStatus
        }
        const res = await exportRemittanceList(params)
        // request 拦截器对 arraybuffer 返回 { __blob: axiosResponse }，取 data
        const raw = res.__blob && res.__blob.data != null ? res.__blob.data : res
        const blob = new Blob([raw], { type: 'text/csv;charset=UTF-8' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `回款订单_${new Date().toISOString().slice(0, 19).replace(/[T:]/g, '')}.csv`
        a.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.remittance-order-page {
  padding: 20px;
}

.search-card {
  margin-bottom: 16px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.amount {
  color: #F56C6C;
  font-weight: 500;
}

.import-tip {
  background: #F5F7FA;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #606266;

  p {
    margin: 0 0 8px 0;
  }

  ul {
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 4px;
  }
}
</style>
